import * as React from "react";
import { Sparkles } from "lucide-react";

import { Button } from "@/components/ui";
import { Media, VideoProject } from "@/services/bedrock";
import { VideoProjectUploader } from "@/components/VideoProjectUploader";
import { VideosSection } from "@/components/VideosSection";

interface Props {
  videoProject: VideoProject;
  handleMediaUpdated: (newMedia: Media[]) => void;
  readOnly?: boolean;
  onOpenQaStudio?: () => void;
}

export const EditorFinalEdit: React.FC<Props> = ({
  videoProject,
  handleMediaUpdated,
  readOnly = false,
  onOpenQaStudio,
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-row justify-between items-center w-full select-none">
        <label className="sectionHeader font-semibold text-slate-800 text-sm flex items-center gap-1.5">
          <Sparkles className="size-4.5 text-blue-600" />
          Final Edit
        </label>
        {onOpenQaStudio ? (
          <Button size="sm" variant="outline" onClick={onOpenQaStudio}>
            View QA studio
          </Button>
        ) : null}
      </div>
      <div className="videoProjectContainer flex flex-col gap-4 bg-slate-50/50 p-5 rounded-xl border border-slate-200 w-full">
        {readOnly ? (
          <VideosSection
            type="EDITED"
            videos={videoProject.editedMedia || []}
            videoProjectId={videoProject.id}
            isEditor={true}
            cols={2}
          />
        ) : (
          <VideoProjectUploader
            editedFile={true}
            handleMediaUpdated={handleMediaUpdated}
            originalMedia={videoProject.editedMedia || []}
            projectId={videoProject.id}
          />
        )}
      </div>
    </div>
  );
};
